import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'routing';
import { MUTATION_KEYS, QUERY_KEYS } from 'shared/constants';
import { useService } from 'shared/providers';
import { UserMapping } from 'shared/types';

export function useDeleteUserMapping() {
  const { userMappingService } = useService();
  const history = useHistory();
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useMutation<void, Error, UserMapping>(request => userMappingService.deleteUserMapping(request), {
    mutationKey: MUTATION_KEYS.deleteUserMapping,
    onSuccess: () => {
      enqueueSnackbar('mapping deleted successfully', { variant: 'success' });
      history.push(ROUTES.userMapping);
    },
    onError: () => {
      enqueueSnackbar('there was a problem deleting mapping', { variant: 'error' });
    },
    onSettled: () => {
      queryClient.invalidateQueries(QUERY_KEYS.userMappings);
    },
  });

  return mutation;
}
